import React, { useCallback, useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IoEyeOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";

import { getOutletAssignedStaffListPath } from "../../../services/config";
import {
  fetchAssAuditStaffData,
  initAuditState,
} from "../../../redux/slices/auditSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { use } from "react";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const OutletAssignedEmployee = () => {
  const [searchParams] = useSearchParams();
  const outletId = searchParams.get("outletId");
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const auditState = useSelector((state) => state.audit);

  const [staffList, setStaffList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);

  const getStaffList = useCallback(() => {
    dispatch(
      fetchAssAuditStaffData(
        `${getOutletAssignedStaffListPath(outletId, user.user_id)}`
      )
    );
  });

  useEffect(() => {
    getStaffList();
  }, []);

  useEffect(() => {
    if (auditState.auditAssStaffSuccess || auditState.auditAssStaffError) {
      if (auditState.auditAssStaffData) {
        const newArr = auditState.auditAssStaffData.filter(
          (row) => row.assignedStatus == "1"
        );
        setFilterEmployeeList(newArr)
        setStaffList(newArr);
        dispatch(initAuditState());
      }
      // auditState.auditAssStaffSuccess ? : toast.error(auditState.auditAssStaffMessage)
    }
  }, [dispatch, auditState]);

  const heading = [
    {
      headerName: "Employee Name",
      field: "fullName",
      flex: 1,
    },

    {
      headerName: "Action",
      width: 200,
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button">
              <Link
                to={`/audit-question-list?outletId=${outletId}&staffId=${rowData.data.staffId}&staffName=${rowData.data.fullName}`}
              >
                <IoEyeOutline
                  style={{
                    cursor: "pointer",
                    fontSize: 25,
                    color: "#58d68d",
                    marginRight: "10px",
                  }}
                />
              </Link>
            </div>
          </>
        );
      },
    },
  ];
  const [searchQuery, setSearchQuery] = useState("")
  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filterEmployeeList.filter((v) =>
      v.fullName.toLowerCase().includes(val.toLowerCase())
    );
    setStaffList(filteredEmployees);
  };

  return (
    <div>
      <div className="page-top-bar">
        <div
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <Link to={"/audit"}>
            <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
          </Link>
          <h1 style={{ fontSize: "20px", fontWeight: "400" }}>Audit</h1>
        </div>
      </div>
      <div
        className="ag-theme-quartz"
        style={{ height: 500, width: "100%", padding: "0 20px" }}
      >
        <input
          type="text"
          onChange={(e) => searchEmployees(e.target.value)}
          placeholder="Search..."
          value={searchQuery}
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            padding: "8px",
            width: "250px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
        <AgGridReact
          rowData={Array.isArray(staffList) ? staffList : []}
          columnDefs={heading}
          omLayout="autoHeight"
          pagination={true}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
        />
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default OutletAssignedEmployee;
